import { ShieldCheck } from "lucide-react";

const Partners = () => {
  return (
    <section className="py-8 bg-neutral-100 border-b border-neutral-200">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 opacity-70 grayscale hover:grayscale-0 transition-all duration-300">
          <div className="flex flex-wrap items-center justify-center gap-3 text-center">
            <ShieldCheck className="w-8 h-8 text-primary" />
            <span className="font-heading text-lg font-bold">KRAVAG-LOGISTIK</span>
            <span className="text-sm font-medium border-l border-neutral-400 pl-3 ml-1">Offizieller Versicherungspartner</span>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Partners;
